import { createFileRoute } from "@tanstack/react-router";

import { PermissionGuard } from "~/components/permission-guard";
import { TesseractDelivery } from "~/modules/projects/components/tesseract-delivery";

export const Route = createFileRoute("/_dash/projects/tesseract")({
  component: TesseractDeliveryPage,
});

function TesseractDeliveryPage() {
  return (
    <PermissionGuard permission="credits:grant">
      <TesseractDelivery />
    </PermissionGuard>
  );
}
